import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);

const DAY_FORMAT = "YYYY,MM,DD";

export const hideExipredEvents = (events: any[]) => {
  const currentDate = dayjs();
  return events.filter((event) => event.date.isSameOrAfter(currentDate, "day"));
};

//used to check if an event is between two dates on the homepage via the date picker
export const checkIfEventIsBetweenDates = (
  event: any,
  startDate: Dayjs | null,
  endDate: Dayjs | null
) => {
  if (startDate == null || endDate == null) {
    return true;
  }
  //   const eventDate = formatDate(event.date);
  if (!event.date.isValid()) {
    console.log("not a valid date");
    return false;
  }
  return event.date.isBetween(startDate, endDate, "day", "[]");
};

export const formatDate = (date: string | Dayjs) => {
  if (typeof date === 'string') {
    let [day, month, year] = date.split("/");
    //watch for issues with single digit month and day
    if (day.length === 1) {
    // todo check if this is still needed
    day = "0" + day;
  }
  // incrementing month by 1 to match the format of the date
    const cleanedDate = `${year},${month},${day}`;
    return dayjs(cleanedDate, DAY_FORMAT);
  }
  return date;
};


type TimeObject = {
  date: Dayjs;
};

export const sortByDateTime = (events: any[]) => {
  return [...events].sort((a, b) => {
    const dateA = dayjs(a.date);
    const dateB = dayjs(b.date);
    return dateA.diff(dateB);
  });
};

export const readableDate = (date: Dayjs) => {
  return dayjs(date).format("DD MMMM YYYY");
};

export const condensedReadableDate = (date: Dayjs) => {
  return dayjs(date).format("DD MMM");
};


// used to format on the single event page
// expects date can be a string formated 2025-10-09T23:00:00.000Z or a Dayjs object
export const formatDateTime = (date: string | Dayjs, startTime: string) => {
  // Parse the date to Dayjs object if it's a string
  const dayJsDate = dayjs.isDayjs(date) ? date : dayjs(date);
  
  // Format the date using dayjs with ordinal date
  const formattedDate = dayJsDate.format('DD MMMM YYYY');

  // Convert 24h time to 12h format
  const formatTime = (time: string) => {
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  return `${formattedDate}, ${formatTime(startTime)}`;
};

